module.exports = __webpack_public_path__ + "static/media/arrow-right.b15971ba.svg";